import { useState, useCallback } from 'react'

import { authHeader, notifyError, notifySuccess } from '../../api/'
import { refreshToken } from '../auth/'

const { REACT_APP_API_URL } = import.meta.env

export const useSetMaintenanceMode = () => {
  const [isLoading, setLoading] = useState(false)
  const [isError, setError] = useState(null)

  const setMaintenanceMode = useCallback(async mode => {
    setError(null)
    setLoading(true)
    try {
      await refreshToken()
      const url = `${REACT_APP_API_URL}/system/maintenance/mode`
      const options = {
        method: 'PATCH',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify({ mode }),
      }
      const response = await fetch(url, options)
      if (!response.ok) {
        const text = await response.text()
        throw new Error(text || `HTTP ${response.status}`)
      }
      const result = await response.json().catch(() => null)

      notifySuccess(
        `Wartungsmeldung ${['deaktiviert', 'aktiviert'][Number(mode)]}`
      )

      return result
    } catch (error) {
      const message = error?.message || 'Fehler beim Setzen des Wartungsmodus'
      setError(message)

      notifyError(message)
      return null
    } finally {
      setLoading(false)
    }
  }, [])

  return { setMaintenanceMode, isLoading, isError }
}
